Controller.$inject = [];

function Controller() {
    const self = this;

    self.$postLink = () => {
        if (self.isStickyHeader === undefined) {
            self.isStickyHeader = true;
        }

        if (self.pageLayout === 'fixed') {
            if (self.headerBg !== 'transparent') {
                console.warn('When pageLayout is "fixed", headerBg should be "transparent". correct headerBg to "transparent".');
            }
            self.headerBg = 'transparent';
        }
    };
}

export function HuiPage() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            headerBg: '@',
            pageLayout: '@',
            isStickyHeader: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui hui-page"
                          ng-class="[$huiCtrl.headerBg || 'default',
                                     $huiCtrl.pageLayout || 'fluid',
                                     $huiCtrl.isStickyHeader ? 'sticky' : ''
                                     ]"
                          ng-transclude></div>`;
        }
    };
}